<template>
  <!--srcAppvuehtmlStart-->

  <div id="defaultId1" class="ucHDVhv" style="height: 100%;overflow: hidden;">
    <router-view id="idQvSVuS" style="height: 100%"> </router-view>
    <div id="g441c3" class="ue6578 ueIA7DU uaBPAwJ uVKKkgA">
      <div id="g9fb19">公共样式配置</div>
      <div id="gcfc5a" class="scrollbar"></div>
    </div>
    <Perfectdata
      @startTime="startTime"
      :loginAndCreatePop.sync="Perfectdatalog"
    ></Perfectdata>
    <!-- <ReLogin :reLoginPop="reLoginVis"></ReLogin> -->
    <!-- <div class="portrait-show flex-center-center">
      <span>请在横屏上查看</span>
    </div> -->
  </div>
  <!--srcAppvuehtmlEnd-->
</template>

<script>
import Perfectdata from "@/components/PerfectData.vue";
// import ReLogin from "@/components/ReLogin.vue"
// interfaceCode

export default {
  name: "",
  props: {},
  mounted() {
    document.title = "CSI"; // 设置页面标题
    this.checkDeviceAndRedirect();

    this.currentObj = this.$route.meta;
    let htmlDom = document.querySelector("html");
    let bodyDom = document.querySelector("body");
    if (htmlDom) {
      if (this.$route.meta.isNewPage) {
        htmlDom.classList.add("html-new-page");
        bodyDom.className = this.currentObj.theme;
      } else {
        htmlDom.classList.remove("html-new-page");
        bodyDom.className = "";
      }
    }
  },
  components: {
    Perfectdata,
    // ReLogin
  },
  data() {
    return {
      istrue: false, // 用于存储某个需要判断的字段
      Perfectdatalog: false,
      timer: null, // 定时器
      token: localStorage.getItem("token"),
      authCode: localStorage.getItem("authCode"),
      reLoginVis: false,
      currentObj: {}, //当前路由meta
      // insertData
      // srcAppvueDataStart

      // srcAppvueDataEnd
    };
  },
  watch: {
    token: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.startTimer();
        } else {
          clearInterval(this.timer);
        }
      },
      immediate: true,
    },
    $route(to, from) {
      // 在这里处理路由变化时的逻辑
      this.currentObj = to.meta;
      let htmlDom = document.querySelector("html");
      let bodyDom = document.querySelector("body");
      if (htmlDom) {
        if (to.meta.isNewPage) {
          htmlDom.classList.add("html-new-page");
          bodyDom.className = this.currentObj.theme;
        } else {
          htmlDom.classList.remove("html-new-page");
          bodyDom.className = "";
        }
      }
    },
  },
  methods: {
    checkDeviceAndRedirect() {
      const currentUrl = window.location.href;
      const mobil = /csiApp/;
      const phone = mobil.test(currentUrl);
      if (!phone) {
        const userAgent = navigator.userAgent;
        // 检查是否是移动设备，但不包括平板
        const isMobile =
          /Mobi|Android/i.test(userAgent) && !/Tablet|iPad/i.test(userAgent);

        if (isMobile) {
          this.$router.push("/csiPhone"); // 跳转到 /phonehome 页面
        }
      }
    },
    startTime(value) {
      clearInterval(this.timer); // 清理定时器
      this.startTimer();
    },
    startTimer() {
      // this.Perfectdatalog = true // 测试
      let certification = JSON.parse(
        localStorage.getItem("userInfo")
      ).certification;
      if (certification != 1 || localStorage.getItem("renzheng")) {
        this.istrue = true;
      } else {
        this.istrue = false;
      }
      this.timer = setInterval(() => {
        if (!this.istrue) {
          this.Perfectdatalog = true; // 显示弹框
          clearInterval(this.timer); // 清理定时器
        } else {
          clearInterval(this.timer);
        }
        // 0000
      }, 3600000); // 每小时检查一次
    },
    // insertMethod
    // srcAppvueMethodStart

    // srcAppvueMethodEnd
  },
  computed: {},
  beforeDestroy() {
    clearInterval(this.timer); // 清理定时器
  },
  updated() {
    window.addEventListener("setItem", () => {
      this.token = localStorage.getItem("token");
    });
  },
};
</script>
<style>
.srcAppvuecssStart {
}

.uVKKkgA {
  display: none;
}

.scrollbar {
  overflow-y: auto;
}

.uVKKkgA .scrollbar {
  height: 100px;
}

.srcAppvuecssEnd {
}
.portrait-show {
  display: none !important;
}
/* 纵向设备 */
@media (orientation: portrait) {
  .portrait-show {
    position: fixed;
    display: flex !important;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 9999;
  }

  .portrait-show span {
    font-family: "DMSans Bold";
    font-size: 60px;
    font-weight: bold;
    color: #ffffff;
    letter-spacing: 20px;
    writing-mode: sideways-rl;
  }
}
</style>
